import Model from './Model'
export default class PaymentTransaction extends Model {

    resource()
    {
        return 'payment-transactions'
    }
}
